import { useEffect, useState } from "react";
import api from "../api";

const MESI = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"];
const EUR = (v) => (v || v === 0 ? Number(v).toLocaleString("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }) : "—");
const EUR2 = (v) => (v || v === 0 ? Number(v).toLocaleString("it-IT", { style: "currency", currency: "EUR", minimumFractionDigits: 2 }) : "—");
const NUM = (v) => Number(v || 0).toLocaleString("it-IT");

const Card = ({ label, value, sub, color, tid }) => (
  <div className="dash-card" data-testid={tid}>
    <div className="num" style={{ fontSize: 22, color }}>{value}</div>
    <div className="lbl">{label}{sub ? <><br /><span style={{ opacity: .75 }}>{sub}</span></> : null}</div>
  </div>
);

export default function Outsourcing() {
  const [d, setD] = useState(null);
  const [tiers, setTiers] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(false);
  const [msg, setMsg] = useState("");
  const [allClients, setAllClients] = useState(false);

  const load = () => api.get("/invoices/outsourcing").then((r) => { setD(r.data); setTiers(r.data.tiers); }).catch(() => {});
  useEffect(() => { if (open && !d) load(); }, [open]); // eslint-disable-line

  const saveTiers = async () => {
    setMsg("");
    try {
      await api.put("/invoices/outsourcing/tariff", { tiers: tiers.map((t) => ({ up_to: Number(t.up_to) || 0, rate: Number(String(t.rate).replace(",", ".")) || 0 })) });
      setEditing(false);
      await load();
      setMsg("Tariffe aggiornate.");
    } catch (e) { setMsg(e.response?.data?.detail || "Salvataggio non riuscito"); }
  };

  if (!open) {
    return (
      <div className="panel" style={{ marginTop: 16 }}>
        <button className="btn" onClick={() => setOpen(true)} data-testid="outsourcing-open">📦 Esternalizzazione registrazioni — quanto costerebbe</button>
      </div>
    );
  }

  const t = d?.totals, e = d?.estimate_year;
  const breakEven = t && t.hours > 0 ? (e.external - e.internal) / e.hours : 0;
  const rows = allClients ? d?.clients : (d?.clients || []).slice(0, 15);

  return (
    <div className="panel" style={{ marginTop: 16 }} data-testid="outsourcing-panel">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
        <h3 style={{ margin: 0 }}>📦 Esternalizzazione registrazioni {d?.year || ""}</h3>
        <div style={{ display: "flex", gap: 6 }}>
          <button className="btn sm" onClick={load} data-testid="outsourcing-reload">🔄 Aggiorna</button>
          <button className="btn sm" onClick={() => setOpen(false)} data-testid="outsourcing-close">✕ Chiudi</button>
        </div>
      </div>

      {!d && <p className="muted">Calcolo in corso…</p>}
      {d && (
        <>
          {/* tariffe */}
          <div style={{ marginTop: 12, padding: 12, border: "1px solid rgba(148,163,184,.2)", borderRadius: 10 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
              <strong style={{ fontSize: 14 }}>Tariffa del fornitore (a scaglioni progressivi, IVA esclusa)</strong>
              {editing ? (
                <span style={{ display: "flex", gap: 6 }}>
                  <button className="btn sm primary" onClick={saveTiers} data-testid="outsourcing-tariff-save">Salva</button>
                  <button className="btn sm" onClick={() => { setTiers(d.tiers); setEditing(false); }} data-testid="outsourcing-tariff-cancel">Annulla</button>
                </span>
              ) : (
                <button className="btn sm" onClick={() => setEditing(true)} data-testid="outsourcing-tariff-edit">✏️ Modifica</button>
              )}
            </div>
            <div style={{ marginTop: 8, display: "flex", flexDirection: "column", gap: 6 }}>
              {tiers.map((tr, i) => {
                const prev = i === 0 ? 0 : Number(tiers[i - 1].up_to) || 0;
                return (
                  <div key={i} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, flexWrap: "wrap" }}>
                    <span className="muted" style={{ minWidth: 150 }}>
                      {Number(tr.up_to) ? `da ${NUM(prev + 1)} a ${NUM(tr.up_to)}` : `oltre ${NUM(prev)}`} reg./mese
                    </span>
                    {editing ? (
                      <>
                        <input style={{ width: 90 }} value={tr.rate} onChange={(ev) => setTiers(tiers.map((x, j) => j === i ? { ...x, rate: ev.target.value } : x))} data-testid={`outsourcing-rate-${i}`} />
                        <span className="muted">€ fino a</span>
                        <input style={{ width: 110 }} value={tr.up_to} onChange={(ev) => setTiers(tiers.map((x, j) => j === i ? { ...x, up_to: ev.target.value } : x))} data-testid={`outsourcing-limit-${i}`} />
                        <span className="muted" style={{ fontSize: 11 }}>(0 = senza limite)</span>
                      </>
                    ) : (
                      <strong>{EUR2(tr.rate)} a registrazione</strong>
                    )}
                  </div>
                );
              })}
            </div>
            {msg && <p className="muted" style={{ marginBottom: 0 }} data-testid="outsourcing-msg">{msg}</p>}
          </div>

          {/* numeri chiave */}
          <div style={{ marginTop: 14, display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))", gap: 10 }}>
            <Card tid="outsourcing-kpi-month" label="Costo esterno al mese" value={EUR(e.monthly_cost)} sub={`su ${NUM(d.avg_docs_month)} reg./mese di media`} color="#f59e0b" />
            <Card tid="outsourcing-kpi-year" label="Costo esterno su 12 mesi" value={EUR(e.external)} sub={`${NUM(e.docs)} registrazioni stimate`} color="#f59e0b" />
            <Card tid="outsourcing-kpi-internal" label="Costo interno equivalente" value={EUR(e.internal)} sub={`${d.minutes_per_document} min × ${EUR(d.hourly_cost)}/ora = ${EUR2(t.cost_per_doc_internal)} a reg.`} color="#34d399" />
            <Card tid="outsourcing-kpi-delta" label={e.external - e.internal >= 0 ? "Differenza: costa di più" : "Differenza: risparmi"} value={EUR(Math.abs(e.external - e.internal))} sub="all'anno" color={e.external - e.internal >= 0 ? "#fb7185" : "#34d399"} />
            <Card tid="outsourcing-kpi-hours" label="Ore liberate all'anno" value={`${NUM(e.hours)} h`} sub={`≈ ${NUM(Math.round(e.hours / 12))} h al mese`} color="#60a5fa" />
            <Card tid="outsourcing-kpi-breakeven" label="Pareggi se ogni ora liberata ti rende almeno" value={`${EUR2(breakEven)}/ora`} sub="di margine in più" color="#a78bfa" />
          </div>

          {/* mesi */}
          <h4 style={{ marginBottom: 6, marginTop: 18 }}>Mese per mese ({d.months_with_data} mesi con dati)</h4>
          <div style={{ overflowX: "auto" }}>
            <table className="table" data-testid="outsourcing-months">
              <thead><tr><th>Mese</th><th style={{ textAlign: "right" }}>Registrazioni</th><th style={{ textAlign: "right" }}>Tariffa media</th><th style={{ textAlign: "right" }}>Costo esterno</th></tr></thead>
              <tbody>
                {d.months.filter((m) => m.docs > 0).map((m) => (
                  <tr key={m.m} data-testid={`outsourcing-month-${m.m}`}>
                    <td>{MESI[m.m - 1]}</td>
                    <td style={{ textAlign: "right" }}>{NUM(m.docs)}</td>
                    <td style={{ textAlign: "right" }} className="muted">{EUR2(m.avg_rate)}</td>
                    <td style={{ textAlign: "right" }}><strong>{EUR2(m.cost)}</strong></td>
                  </tr>
                ))}
                <tr>
                  <td><strong>Totale</strong></td>
                  <td style={{ textAlign: "right" }}><strong>{NUM(t.docs)}</strong></td>
                  <td />
                  <td style={{ textAlign: "right" }}><strong>{EUR2(t.external)}</strong></td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* clienti */}
          <h4 style={{ marginBottom: 6, marginTop: 18 }}>Per cliente ({d.clients_count} clienti con registrazioni)</h4>
          <div style={{ overflowX: "auto" }}>
            <table className="table" data-testid="outsourcing-clients">
              <thead><tr><th>Cliente</th><th style={{ textAlign: "right" }}>Registrazioni</th><th style={{ textAlign: "right" }}>Ore</th><th style={{ textAlign: "right" }}>Costo esterno</th><th style={{ textAlign: "right" }}>Costo interno</th><th style={{ textAlign: "right" }}>Differenza</th></tr></thead>
              <tbody>
                {(rows || []).map((c) => {
                  const diff = c.external_cost - c.internal_cost;
                  return (
                    <tr key={c.company_id} data-testid={`outsourcing-client-${c.company_id}`}>
                      <td>{c.name}</td>
                      <td style={{ textAlign: "right" }}>{NUM(c.docs)}</td>
                      <td style={{ textAlign: "right" }} className="muted">{NUM(c.hours)} h</td>
                      <td style={{ textAlign: "right" }}>{EUR2(c.external_cost)}</td>
                      <td style={{ textAlign: "right" }} className="muted">{EUR2(c.internal_cost)}</td>
                      <td style={{ textAlign: "right", color: diff >= 0 ? "#fb7185" : "#34d399" }}>{diff >= 0 ? "+" : ""}{EUR2(diff)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {d.clients.length > 15 && (
            <button className="btn sm" style={{ marginTop: 8 }} onClick={() => setAllClients(!allClients)} data-testid="outsourcing-clients-toggle">
              {allClients ? "Mostra solo i primi 15" : `Mostra tutti i ${d.clients_count} clienti`}
            </button>
          )}
          <p className="muted" style={{ fontSize: 12, marginTop: 12 }}>
            Le registrazioni arrivano dalla board Contabilità: i mesi non ancora compilati valgono zero e abbassano la media.
            Gli scaglioni si applicano al volume complessivo dello studio, quindi per i singoli clienti è usata la tariffa media del mese.
            Il costo interno usa i parametri di Impostazioni → Margini ({d.minutes_per_document} minuti per registrazione, {EUR(d.hourly_cost)} l'ora) e il pareggio presuppone che quelle ore non vengano più pagate internamente.
          </p>
        </>
      )}
    </div>
  );
}
